import 'uni-pages';import 'uni-h5';import Vue from 'vue'
import App from './App'
import store from '@/store/index.js'; // VUEX
import start from './start/index.js' // 开始配置文件

start()
App.mpType = 'app'
const app = new Vue({
	...App,
	store
})
app.$mount()